import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as ChannelTalkFloatIcon } from '../icon/channel_talk_float_icon.svg';
import ChannelTalkContext from '../context/ChannelTalkContext';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';

const ChannelTalkButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const { isChannelLoaded, onShowMessenger, onHideMessenger } = useContext(ChannelTalkContext);

  useEffect(() => {
    onShowMessenger(() => setIsOpen(true));
    onHideMessenger(() => setIsOpen(false));
    ChannelService.onBadgeChanged((count) => setUnreadCount(count));
  }, [onShowMessenger, onHideMessenger]);

  useEffect(() => {
    if (!isChannelLoaded) return;
    const hide = () => {
      if (window.innerWidth >= 1024) ChannelService.hideChannelButton();
    };
    hide();
    window.addEventListener('resize', hide);
    return () => window.removeEventListener('resize', hide);
  }, [isChannelLoaded]);

  const handleClick = () => {
    if (isOpen) {
      ChannelService.hideMessenger();
    } else {
      ChannelService.showMessenger();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed top-1/2 -translate-y-1/2 right-6 z-50 hidden md:block"
      aria-label="채널톡 상담"
    >
      <ChannelTalkFloatIcon className="w-20 h-20" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ChannelTalkButton;
